import {DropdownItemTextEnum} from '../enums';
import {getDynamicExpirationText} from './getDynamicExpirationText';
import {getDynamicNextYearExpirationText} from './getDynamicNextYearExpirationText';

export const filesDropdownList = () => [
  {
    text: DropdownItemTextEnum.open,
    isOpenInNewWindow: true,
  },
  {
    text: DropdownItemTextEnum.copyLink,
    isCopyLink: true,
  },
  {
    text: getDynamicExpirationText(),
    isCopyCurrentYearExpireableLink: true,
  },
  {
    text: getDynamicNextYearExpirationText(),
    isCopyNextYearExpireableLink: true,
  },
  {
    text: DropdownItemTextEnum.download,
    isDownload: true,
  },
];
